import React from 'react';
import { FaVoteYea,FaStamp,FaIdCardAlt } from "react-icons/fa";
import {
  IoMdMenu,
  IoIosSearch,
  IoIosNotifications,
  IoIosNotificationsOff,
  IoIosChatbubbles,
  IoMdCart,
  IoMdMail,
  IoMdBasket,
  IoMdMap,
  IoIosPerson,
  IoIosApps,
  IoMdCheckboxOutline,
  IoIosToday,
  IoLogoYoutube,
  IoIosPaper,
  IoMdFlame,
  IoMdPersonAdd,
  IoIosKeypad,
  IoMdTrendingUp,
  IoMdListBox,
  IoIosLeaf,
  IoIosFlash,
  IoMdThumbsUp,
  IoMdGrid,
  IoIosCopy,
  IoLogoGithub,
  IoIosDocument,
  IoMdOptions,
  IoIosMailUnread,
  IoMdCamera,
  IoMdChatboxes,
  IoMdCloudDownload,
  IoIosMusicalNotes,
  IoIosPie,
  IoMdTrophy,
  IoMdCloudUpload,
  IoLogoFacebook,
  IoLogoTwitter,
  IoLogoGoogleplus,
  IoLogoLinkedin,
  IoLogoDribbble,
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdTrash,
  IoMdFolder,
  IoMdPricetags,
  IoMdArchive,
  IoMdAlert,
  IoMdAdd,
  IoMdClose,
  IoMdMic,
  IoIosSquare,
  IoMdCreate,
  IoIosHammer,
  IoIosStats,
  IoIosListBox,
  IoIosCube,
  IoIosPeople,
  IoIosMegaphone,
  IoIosCalendar,
  IoIosCreate,
  IoIosCall,
  IoIosContact,
  IoIosHelpCircle,
  IoIosVideocam,
  IoIosOptions,
  IoIosFitness,
  IoIosCash,
  IoIosInformationCircle,
  IoMdSync,
  IoIosCar,
  IoMdWalk
} from 'react-icons/io';
import { IoLocate, IoAlertCircleSharp } from "react-icons/io5";
import { RiServiceFill } from "react-icons/ri";
import { AiFillAlert } from "react-icons/ai";
import { GoReport } from "react-icons/go";

// TopBar Icons
export const TopbarMenuIcon = IoMdMenu; // Menu icon
export const TopbarSearchIcon = IoIosSearch; // Search icon
export const TopbarNotifyIcon = IoIosNotifications; // Notification icon
export const TopbarNotifyOffIcon = IoIosNotificationsOff;  // Notification icon
export const TopbarMailIcon = IoMdMail; // Notification icon
export const TopbarMessageIcon = IoIosChatbubbles; // Chat icon
export const TopbarCartIcon = IoMdCart; // Cart icon

//URBANCIE ICONS
export const IoIosStatsIcon = IoIosStats; //Dashboard
export const IoIosListBoxIcon = IoIosListBox; //Issue Tracking
export const IoIosHammerIcon = IoIosHammer; //Repair
export const IoIosCubeIcon = IoIosCube; //Parcel
export const IoIosPeopleIcon = IoIosPeople; //Directory
export const IoIosMegaphoneIcon = IoIosMegaphone; //Announcement
export const IoIosFitnessIcon = IoIosFitness; //Facility
export const IoIosCashIcon = IoIosCash; //Payment Reminder
export const IoIosCreateIcon = IoIosCreate; //Suggestion
export const IoIosCallIcon = IoIosCall; //Phonebook
export const IoIosInformationCircleIcon = IoIosInformationCircle; //Contact Niti
export const IoIosHelpCircleIcon = IoIosHelpCircle; //Help
export const IoIosVideocamIcon = IoIosVideocam; //Tutorial
export const IoIosOptionsIcon = IoIosOptions; //Settings
export const IoIosChatbubblesIcon = IoIosChatbubbles; //Chat
export const IoIosMdSync = IoMdSync; //Recycling
export const FaFaVoteYea = FaVoteYea; //AGM Meeting
export const FaFaStamp = FaStamp; //VMS Stamp
export const FaFaIdCardAlt = FaIdCardAlt; //VMS
export const IoIoMdWalk = IoMdWalk; //VMS
export const IoIoLocate = IoLocate; //Patrol
export const IoIoAlertCircleSharp = IoAlertCircleSharp; //SOS
export const AiAiFillAlert = AiFillAlert; //SOS
export const RiRiServiceFill = RiServiceFill; //LOS Services


// SideBar Icons
export const SidebarIdCard = IoIosCar; //VMS
export const SidebarEmailIcon = IoMdMail; // Email icon
export const SidebarChatIcon = IoIosChatbubbles; // Chat icon
export const SidebarEcommerceIcon = IoMdBasket; // E-commerce icon
export const SidebarMapsIcon = IoMdMap; // Map icon
export const SidebarProfileIcon = IoIosPerson; // Profile icon
export const SidebarScrumBoardIcon = IoIosApps; // Scrum Board icon
export const SidebarInvoiceIcon = IoIosToday; // Invoice icon
export const SidebarYouTubeIcon = IoLogoYoutube; // YouTube icon
//export const SidebarCalendarIcon = IoIosCalendar; // Calendar icon
// export const SidebarNotesIcon = IoIosPaper; // Notes icon
export const SidebarToDosIcon = IoMdCheckboxOutline; // ToDos icon
export const SidebarFireStoreIcon = IoMdFlame; // FireStore Crud icon
export const SidebarContactsIcon = IoMdPersonAdd; // Contacts icon
export const SidebarShuffleIcon = IoIosKeypad; // Shuffle icon
export const SidebarChartsIcon = IoMdTrendingUp; // Chart icon
export const SidebarFormsIcon = IoMdListBox; // Forms icon
export const SidebarUIIcon = IoIosLeaf; // UI Elements icon
export const SidebarAdvancedIcon = IoIosFlash; // Advanced Elements icon
export const SidebarFeedbackIcon = IoMdThumbsUp; // Feedback icon
export const SidebarTablesIcon = IoMdGrid; // Tables icon
export const SidebarPagesIcon = IoIosCopy; // Pages icon
export const SidebarGithubIcon = IoLogoGithub; // Github Search icon
export const SidebarBlankIcon = IoIosDocument; // Blank Page icon
export const SidebarMenuLevelIcon = IoMdOptions; // Menu levels icon


// Dashboard Widgets Icons
export const StickerWidgetUnreadMailIcon = IoIosMailUnread; // Unread email icon
export const StickerWidgetImgUploadIcon = IoMdCamera; // Image Upload icon
export const StickerWidgetMessageIcon = IoIosChatbubbles; // Total Messages icon
export const StickerWidgetOrderIcon = IoMdCart; // Order Post icon

export const CardWidgetNewMsgIcon = IoMdChatboxes; // Card New Message icon
export const CardWidgetVolumeIcon = IoIosMusicalNotes; // Card Volume icon
export const CardWidgetAchievementIcon = IoMdTrophy; // Card Achievement icon

export const ProgressDownloadIcon = IoMdCloudDownload; // Card Download icon
export const ProgressPieChartIcon = IoIosPie; // Card Pie icon
export const ProgressUploadIcon = IoMdCloudUpload; // Card Upload icon

export const SocialFacebookIcon = IoLogoFacebook; // Social Facebook icon
export const SocialTwitterIcon = IoLogoTwitter; // Social Twitter icon
export const SocialGooglePlusIcon = IoLogoGoogleplus; // Social Google Plus icon
export const SocialLinkedinIcon = IoLogoLinkedin; // Social Linkedin icon
export const SocialDribbbleIcon = IoLogoDribbble; // Social Dribbble icon

// Mail Icons
export const MailDeleteIcon = IoMdTrash; // Mail Delete icon
export const MailFolderIcon = IoMdFolder; // Mail Move icon
export const MailTagIcon = IoMdPricetags; // Mail Tag icon
export const MailArchiveIcon = IoMdArchive; // Mail Archive icon
export const MailSpamReportIcon = IoMdAlert; // Mail Report icon

// E-commerce Icons
export const VoiceSearchMicIcon = IoMdMic; // Voice Search icon
export const VoiceSearchStopIcon = IoIosSquare; // Voice Search icon
export const GridViewIcon = IoIosKeypad; // Grid View icon
export const ListViewIcon = IoMdMenu; // List View icon

// Common Icons
export const ArrowLeftIcon = IoIosArrowBack; // Arrow Left icon
export const ArrowRightIcon = IoIosArrowForward; // Arrow Right icon
export const AddIcon = IoMdAdd; // Add icon
export const CloseIcon = IoMdClose; // Close icon
export const CartIcon = IoMdCart; // Cart icon
export const DeleteIcon = IoMdTrash; // Delete icon
export const EditIcon = IoMdCreate; // Edit icon
export const MenuIcon = IoMdMenu; // Edit icon
export const FlameIcon = IoMdFlame; // Flame icon
